document.addEventListener("DOMContentLoaded", function () {
  // Orders placed before this hour (store local time) ship next day; after it, the day after.
  var CUTOFF_HOUR = 5;
  var STORE_TIMEZONE = "America/Chicago";
  var REFRESH_INTERVAL_MS = 60000;

  // Reads the wall-clock time in the store's timezone regardless of the visitor's own timezone.
  // Intl handles daylight-saving transitions, so no timezone database needs to ship to the browser.
  var partsFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: STORE_TIMEZONE,
    hour12: false,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  });

  var deliveryFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "UTC",
    weekday: "long",
    month: "long",
    day: "numeric"
  });

  function storeNow() {
    var parts = {};
    partsFormatter.formatToParts(new Date()).forEach(function (part) {
      if (part.type !== "literal") parts[part.type] = parseInt(part.value, 10);
    });
    // Hour 24 is how some engines report midnight in hour12:false mode.
    if (parts.hour === 24) parts.hour = 0;
    return parts;
  }

  function updateCountdown() {
    var now = storeNow();
    if (isNaN(now.hour)) return;

    var minutesNow = now.hour * 60 + now.minute;
    var minutesCutoff = CUTOFF_HOUR * 60;
    var diffInMinutes = minutesCutoff - minutesNow;
    // Past today's cutoff, count down to tomorrow's.
    if (diffInMinutes <= 0) diffInMinutes += 24 * 60;
    // Round up so a partially elapsed minute is not shown as already gone.
    if (now.second > 0) diffInMinutes -= 1;

    var timeText;
    if (diffInMinutes <= 0) {
      timeText = "0 hours 0 minutes";
    } else {
      timeText = Math.floor(diffInMinutes / 60) + " hours " + (diffInMinutes % 60) + " minutes";
    }

    // Build the delivery date from the store's calendar date in UTC, so adding days
    // cannot be shifted by the visitor's own timezone offset.
    var deliveryDate = new Date(Date.UTC(now.year, now.month - 1, now.day));
    deliveryDate.setUTCDate(deliveryDate.getUTCDate() + (now.hour >= CUTOFF_HOUR ? 2 : 1));
    var deliveryText = deliveryFormatter.format(deliveryDate);

    document.querySelectorAll("[data-delivery-date]").forEach(function (el) {
      el.textContent = deliveryText;
    });
    document.querySelectorAll("[data-time-remaining]").forEach(function (el) {
      el.textContent = timeText;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, REFRESH_INTERVAL_MS);
});
